import { render, staticRenderFns } from "./CommitteeCommunication.vue?vue&type=template&id=40e2a963&scoped=true"
import script from "./CommitteeCommunication.vue?vue&type=script&lang=js"
export * from "./CommitteeCommunication.vue?vue&type=script&lang=js"
import style0 from "./CommitteeCommunication.vue?vue&type=style&index=0&id=40e2a963&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e2a963",
  null
  
)

export default component.exports